import { InvoiceForm } from '@features/invoices/types/invoiceForm/invoiceForm'
import { InvoiceFormRowLine } from '@features/invoices/types/invoiceForm/invoiceFormLine/invoiceFormRowLine'

const INVOICE_LINES_KEY = 'invoiceLines' satisfies keyof InvoiceForm

/**
 * Returns true for RHF watch names that represent:
 * - the full invoiceLines array (add / remove / reorder): "invoiceLines"
 * - a single line's specific field: "invoiceLines.<index>.<fieldKey>"
 */
export const getIsInvoiceLinesChange = (
  changedPath: string | undefined,
  fieldKey: keyof InvoiceFormRowLine,
): boolean => {
  const isInvoiceLinesChange = changedPath === INVOICE_LINES_KEY
  if (isInvoiceLinesChange) {
    return true
  }

  // RHF dot-path: invoiceLines.<index>.<fieldKey>
  const parts = changedPath?.split('.')
  const isInvoiceLinesFieldChange = parts?.[0] === INVOICE_LINES_KEY
  const isTargetFieldChange = parts?.[2] === fieldKey

  return isInvoiceLinesFieldChange && isTargetFieldChange
}
